import { render, staticRenderFns } from "./SwitchByUa.vue?vue&type=template&id=983da426&"
import script from "./SwitchByUa.vue?vue&type=script&lang=ts&"
export * from "./SwitchByUa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports